//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The ticket metadata model, which contains additional information about the ticket
* 
* @param row The number/designation of the row
* @param seat The number/designation of the seat
* @param gate The assigned entrance gate
* @param section The assigned seating area
*/
@Serializable

data class Seating (


      /* The number/designation of the row */
    @SerialName(value = "row") @Required val row: kotlin.String,


      /* The number/designation of the seat */
    @SerialName(value = "seat") @Required val seat: kotlin.String,


      /* The assigned entrance gate */
    @SerialName(value = "gate") val gate: kotlin.String? = null,


      /* The assigned seating area */
    @SerialName(value = "section") val section: kotlin.String? = null


) {




  }

